import { createAction } from '@reduxjs/toolkit';

export const authHelperActions = {
	hydrate: createAction(`auth/hydrate`),
};
